/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control,Drug A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const es_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control,Droga A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const de_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontrolle,Medikament A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const nl_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control,Drug A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const fr_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contrôle,Médicament A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const it_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controllo,Farmaco A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const pt_br2_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle,Droga A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const pt_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlo,Fármaco A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const ja_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Control,Drug A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

const zh_violin_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对照组,药物 A
5.1,7.2
5.4,7.8
4.9,6.9`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_placeholder", locale)
	if (locale === "en") return en_violin_placeholder(inputs)
	if (locale === "es") return es_violin_placeholder(inputs)
	if (locale === "de") return de_violin_placeholder(inputs)
	if (locale === "nl") return nl_violin_placeholder(inputs)
	if (locale === "fr") return fr_violin_placeholder(inputs)
	if (locale === "it") return it_violin_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_violin_placeholder(inputs)
	if (locale === "pt") return pt_violin_placeholder(inputs)
	if (locale === "ja") return ja_violin_placeholder(inputs)
	return zh_violin_placeholder(inputs)
};